// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__L32O8","forms":"Login_forms__2iBAI"};